import { WIDGET_DEFAULT_FONT } from 'constants/fonts';
import { WidgetType } from 'types/widget.types';

import { ChartWidgetData } from './ChartWidget.types';

export const chartColorPalette = ['#003F7F', '#0298A6', '#7047EB', '#0069D1', '#B24DC0'];

export const extendedChartColorPalette = ['#D44596', '#ff4f85', '#E76E3C', '#959819', '#589B46', '#008577', '#005E54'];

export const DEFAULT_FONT_FAMILY = WIDGET_DEFAULT_FONT;

export const MIN_TABLE_ROWS = 20;
export const MIN_TABLE_COLUMNS = 10;

export const DEFAULT_NUMBER_FORMAT = 'value';

// @deprecated keep for fallback only
// @see NumberFormat.config.ts
export const LEGACY_NUMBER_SEPARATOR = 'none';

export const DEFAULT_Y2_Label_TOGGLE = true;

// The valid delimiters used in separating a number
// Ex: 1,000,000.00
// The ',' is the delimiter
export const DELIMITERS_REGEX = /[ ,;]/g;

export const DEFAULT_GENERAL_OPTIONS: ChartWidgetData['generalOptions'] = {
  innerSize: 0,
  borderWidth: 1,
  borderColor: '#FFFFFF',
};

// Default styling for labels, legend, and other texts in the chart
export const DEFAULT_TEXT_STYLE = {
  color: '#000',
  fontFamily: DEFAULT_FONT_FAMILY,
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: 'normal',
  textOutline: 'none',
  textDecoration: 'none',
};

// List of charts that can auto convert between single and multi series according to the data
export const ALLOW_SINGLE_SERIES_CHARTS = [
  WidgetType.BarChart,
  WidgetType.ColumnChart,
  WidgetType.StackedBarChart,
  WidgetType.StackedColumnChart,
];

// List of charts that can only be single series.
// If the data is multiple series, such as multiple columns, the chart will use only one column as series data
export const FORCE_SINGLE_SERIES_CHARTS = [
  WidgetType.HalfPieChart,
  WidgetType.HistogramChart,
  WidgetType.PieChart,
  WidgetType.WordCloudChart,
  WidgetType.FunnelChart,
];

export const SINGLE_COLUMN_CHARTS = [WidgetType.HistogramChart];
